export class DocumentosPosRecadDto{
    recadValidacaoDocPessoaisId: number;
    validacaoRecadId: number;

    numeCartIdentSrh: string;
    numeCartIdentRecad: string;
    descOrgEmisCartIdentSrh: string;
    descOrgEmisCartIdentRecad: string;
    dataEmissaoCartIdentSrh: string;
    dataEmissaoCartIdentRecad: string;

    numeCnhSrh: string;
    numeCnhRecad: string;
    ufCnhSrh: string;
    ufCnhRecad: string;
    dataExpedCnhSrh: string;
    dataExpedCnhRecad: string;
    dataPrimeiraCnhRecad: string;
    
    numeTituloEleitorSrh: string;
    numeTituloEleitorRecad: string;
    numeZonaTitEleitorSrh: string;
    numeZonaTitEleitorRecad: string;
    numeSecaoTitEleitorSrh: string;
    numeSecaoTitEleitorRecad: string;
    ufTituloEleitorSrh: string;
    ufTituloEleitorRecad: string;
    dataVencimentoCnhSrh: string;
    dataVencimentoCnhRecad: string;
    codgUfCartIdentidadeSrh: string;
    codgUfCartIdentidadeRecad: string;
    descCategoriaCnhSrh: string;
    descCategoriaCnhRecad: string;
    possuiAlteracaoCnh: boolean;
    possuiAlteracaoRg: boolean;
    possuiAlteracaoTituloEleitor: boolean;
}
